module.exports = "https://99designs-start-assets.imgix.net/js/e95186b8fe07d93022cb64cad53dc69f.png";